import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  fetchBackupDeviceListAdmin,
  fetchBackupDeviceListAxios,
  fetchFolderDelete,
} from "../../../api/admin";
import {
  BackupContainer,
  ContentsBody,
} from "../../../style/contents/backup/backup";
import ContentsTopHeader from "../../../components/common/contents.top.header";
import DeviceList from "../../../components/backup/device.list";
import { useAuthStore } from "../../../atoms/user.auth.store";

export interface DeviceItem {
  deviceId: string;
  rootDirectoryList: string[];
  userId: number;
  userAccount: string;
  userName: string;
  userEmail: string;
  isAdmin: boolean;
  originIp: string;
  pcName: string;
}

type DeviceListType = DeviceItem[];

const BackupDeviceList = () => {
  const { id } = useParams<{ id: string }>();
  const { role } = useAuthStore(); // ✅ role 가져오기
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const encodedDept = params.get("department") || "";
  const department = decodeURIComponent(atob(encodedDept));

  const [searchKeyword, setSearchKeyword] = useState("");
  const [pageSize, setPageSize] = useState("10");
  const [data, setData] = useState<DeviceListType>([]);
  const [selectedDevices, setSelectedDevices] = useState<string[]>([]);

  const userId = localStorage.getItem("userId");

  const handleSelectChange = (deviceId: string, checked: boolean) => {
    setSelectedDevices((prev) =>
      checked ? [...prev, deviceId] : prev.filter((id) => id !== deviceId),
    );
  };

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedDevices(data.map((d) => d.deviceId));
    } else {
      setSelectedDevices([]);
    }
  };

  const isAllSelected =
    data.length > 0 && selectedDevices.length === data.length;

  const handleSearch = (keyword: string) => {
    setSearchKeyword(keyword);
    // TODO: fetchData(keyword, pageSize);
  };

  const handlePageSizeChange = (size: string) => {
    setPageSize(size);
    // TODO: fetchData(searchKeyword, size);
  };

  // // admin 계정으로 디바이스 목록 불러오기
  // useEffect(() => {
  //   console.log("📌 id:", id);

  //   const loadDeviceList = async () => {
  //     try {
  //       const response = await fetchBackupDeviceListAdmin(Number(adminUserId));
  //       console.log("📦 전체 응답:", response);

  //       if (response && response.userList) {
  //         const filtered = response.userList.filter(
  //           (item: any) => item.userId === Number(id)
  //         );
  //         console.log("device response:", response);
  //         console.log("✅ 필터링된 리스트:", filtered);
  //         setData(filtered);
  //       }
  //     } catch (err) {
  //       console.error("🚨 오류 발생:", err);
  //     }
  //   };

  //   loadDeviceList();
  // }, []);

  // ✅ 디바이스 목록 불러오기
  useEffect(() => {
    const loadDeviceList = async () => {
      try {
        if (role === "admin") {
          const response = await fetchBackupDeviceListAdmin(Number(userId));
          const filtered = response.userList.filter(
            (item: any) => item.userId === Number(id),
          );

          setData(filtered);
        } else {
          // user는 자기 자신의 리스트만 봄
          const response = await fetchBackupDeviceListAxios(Number(userId));
          setData(response.deviceList || []);
        }
      } catch (err) {
        console.error("🚨 디바이스 불러오기 실패:", err);
      }
    };

    loadDeviceList();
  }, [role, id, userId]);

  const handleDeleteDevices = async () => {
    if (selectedDevices.length === 0) {
      alert("삭제할 디바이스를 선택해주세요.");
      return;
    }

    const confirmDelete = window.confirm("선택한 디바이스를 삭제하시겠습니까?");
    if (!confirmDelete) return;

    try {
      await Promise.all(
        selectedDevices.map(async (deviceId) => {
          const res = await fetchFolderDelete(
            userId ?? "",
            Number(id),
            deviceId,
          );
          console.log(`✅ ${deviceId} 삭제 성공`, res);
        }),
      );

      alert("선택한 디바이스가 삭제되었습니다.");

      // 삭제 후 목록 갱신
      const response = await fetchBackupDeviceListAdmin(Number(userId));
      if (response && response.userList) {
        const filtered = response.userList.filter(
          (item: any) => item.userId === Number(id),
        );
        setData(filtered);
        setSelectedDevices([]); // 선택 초기화
      }
    } catch (err) {
      console.error("❌ 삭제 실패:", err);
      alert("디바이스 삭제 중 오류가 발생했습니다.");
    }
  };

  return (
    <BackupContainer>
      <ContentsTopHeader
        title="디바이스 목록"
        backArrowPath={role === "admin" ? "/backup/user" : undefined}
      />
      <ContentsBody>
        {/* <div className="total">총 {data && data.length}</div> */}
        <div className="top-components">
          <div className="l">
            {role === "admin" && (
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
                id="allSelect"
              />
            )}
            {role === "admin" ? (
              <label htmlFor="allSelect">
                전체 선택 (0 / {data && data.length})
              </label>
            ) : (
              <label htmlFor="allSelect">전체 {data && data.length}</label>
            )}
          </div>
          {role === "admin" && (
            <div className="r">
              <button
                disabled={selectedDevices.length === 0}
                onClick={handleDeleteDevices} // 🔁 변경됨
              >
                선택 삭제
              </button>
            </div>
          )}
        </div>
        <div className="hr"></div>
        <DeviceList
          data={data}
          selectedDevices={selectedDevices}
          onSelectChange={handleSelectChange}
          role={role || ""}
          department={department}
          folderPathPrefix="/backup/folder"
        />
      </ContentsBody>
    </BackupContainer>
  );
};

export default BackupDeviceList;
